import {
    BrowserRouter as Router,
    Switch,
    Redirect,
    Route,
} from "react-router-dom";
import { HomeScreen } from '../screens/HomeScreen';
import ScrollToTop from "../components/ScrollToTop";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { reorderArray } from "../utils/Utilities";
import { collection, getDocs, getDocsFromCache } from "firebase/firestore";
import { removeCheckingFallHerramientasBrands, removeCheckingFallHerramientasProducts, removeCheckingFallHerramientasProfit, saveFallHerramientasBrands, saveFallHerramientasProducts, saveFallHerramientasProfit } from "../actions/fallHerramientas";
import { firestore } from "../firebase/firebase-config";

export const AppRouter = () => {

    const dispatch = useDispatch()

    useEffect(() => {

        let cancelled = false;

        /// Each collection is loaded on its own, the way the previous listeners worked:
        /// a failure reading one must never blank out the other two.
        const load = async (name: string, publish: (snapshot: any) => void) => {

            const reference = collection(firestore, name);

            /// Paint whatever the local cache holds first. getDocs on its own waits for the
            /// server round trip, which would cancel out the persistent cache entirely.
            try {

                const cached = await getDocsFromCache(reference);

                if (!cached.empty && !cancelled) publish(cached);

            } catch (error) {

                /// First visit, or storage unavailable. The server read below covers it.

            }

            /// Then refresh from the server, so a cached price is never the last word.
            try {

                const fresh = await getDocs(reference);

                if (!cancelled) publish(fresh);

            } catch (error) {

                console.error(`[Firestore] Failed to read the "${name}" collection.`, error);

            }

        }

        load("Products", (snapshot) => {

            dispatch(saveFallHerramientasProducts(snapshot.docs.map((doc: any) => ({ id: doc.id, ...doc.data() }))));

            dispatch(removeCheckingFallHerramientasProducts());

        });

        load("Brands", (snapshot) => {

            dispatch(saveFallHerramientasBrands(reorderArray(snapshot.docs.map((doc: any) => ({ id: doc.id, ...doc.data() })))));

            dispatch(removeCheckingFallHerramientasBrands());

        });

        load("Config", (snapshot) => {

            dispatch(saveFallHerramientasProfit(snapshot.docs.map((doc: any) => ({ ...doc.data() }))[0]));

            dispatch(removeCheckingFallHerramientasProfit());

        });

        return () => { cancelled = true; }

    }, [dispatch]);

    return (

        <Router>

            <div>

                <ScrollToTop />

                <Switch>

                    <Route
                        exact
                        path='/'
                        component={HomeScreen}
                    />

                    <Redirect to='/' />

                </Switch>

            </div>

        </Router>

    )
}
